import styled from 'styled-components';

//components
import {Button} from 'components/Button';
import {SignInOptionButtonMobile, SignInOptionButtonDesktop} from 'components/SignInOptionButton';

export const PickerContainer = styled.div`
  flex: 5;
`;

export const StyledSignInOptionButtonMobile = styled(SignInOptionButtonMobile)`
  margin-bottom: 16px;
`;

export const StyledSignInOptionButtonDesktop = styled(SignInOptionButtonDesktop)`
  margin-bottom: 16px;
`;

export const StyledButton = styled(Button).attrs({
  design: 'text-alternative-hover'
})`
  text-transform: unset !important;
  margin: auto;
`;
